
export default {
    namespaced: true,
    state: {
        positionsData: [],
        fieldHeader: [],
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        siteList: [],
        regionList: [],
        currentRegionData: {},
        currentRegionId: null,
        currentSiteId: null,
        currentSearchEngine: 'yandex',
        searchValue: '',
        sortField: 'brand.name',
        sortDir: 'asc',
        historyData: {},
    },
    getters: {
        HISTORY_DATA: state => {
            return state.historyData;
        },
        FIELD_HEADER: state => {
            return state.fieldHeader;
        },
        SORT_FIELD: state => {
            return state.sortField;
        },
        SORT_DIR: state => {
            return state.sortDir;
        },
        SEARCH_VALUE: state => {
            return state.searchValue;
        },
        CURRENT_REGION_ID: state => {
            return state.currentRegionId;
        },
        CURRENT_SITE_ID: state => {
            return state.currentSiteId;
        },
        CURRENT_SEARCH_ENGINE: state => {
            return state.currentSearchEngine;
        },
        SITE_LIST: state => {
            return state.siteList;
        },
        REGION_LIST: state => {
            return state.regionList;
        },
        CURRENT_REGION_DATA: state => {
            return state.currentRegionData;
        },
        POSITIONS_DATA: state => {
            return state.positionsData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        }
    },
    mutations: {
        HISTORY_DATA: (state, payload) => {
            return state.historyData = payload;
        },
        FIELD_HEADER: (state, payload) => {
            return state.fieldHeader = payload;
        },
        SEARCH_VALUE: (state, payload) => {
            return state.searchValue = payload;
        },
        SORT_FIELD: (state, payload) => {
            return state.sortField = payload;
        },
        SORT_DIR: (state, payload) => {
            return state.sortDir = payload;
        },
        CURRENT_REGION_ID: (state, payload) => {
            return state.currentRegionId = payload;
        },
        CURRENT_SITE_ID: (state, payload) => {
            return state.currentSiteId = payload;
        },
        CURRENT_SEARCH_ENGINE: (state, payload) => {
            return state.currentSearchEngine = payload;
        },
        SITE_LIST: (state, payload) => {
            return state.siteList = payload;
        },
        REGION_LIST: (state, payload) => {
            return state.regionList = payload;
        },
        CURRENT_REGION_DATA: (state, payload) => {
            return state.currentRegionData = payload;
        },
        POSITIONS_DATA: (state, payload) => {
            return state.positionsData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_DATA: async ({state, commit}, payload) => {
            payload.th.showOverlay ++;
            let params = {
                perPage:                state.perPage,
                currentPage:            state.currentPage,
                currentSearchEngine:    state.currentSearchEngine,
                currentRegionId:        state.currentRegionId,
                searchValue:            state.searchValue,
                sortField:              state.sortField,
                sortDir:                state.sortDir,
            }
            let createParamsUrl = function (params) {
                let urlParams = [];
                for (let prop in params) {
                    if (params[prop] !== false && params[prop] !== '' && params[prop] !== "[]" && params[prop] !== null) {
                        urlParams.push(prop + '=' + encodeURIComponent(params[prop]));
                    }
                }
                return '?' + urlParams.join('&');
            }
            let urlParams = createParamsUrl(params);
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-positions/'+ state.currentSiteId + urlParams,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data;
                    data.positions = data.positions == null ? [] : data.positions
                    state.positionsData = payload.th.sortPositionData(data.positions);
                    state.totalRows = data.count;
                    commit('FIELD_HEADER', data.fieldHeader)
                    state.currentRegionData = data.currentRegionData;
                    // set site list
                    state.siteList = [];
                    for (let key in data.sites) {
                        let val = data.sites[key]
                        state.siteList.push({
                         value: val.id.toString(), text: val.domain
                        })
                    }
                    // set region list
                    state.regionList = [];
                    for (let key in data.regions) {
                        let val = data.regions[key]
                        let lang = state.currentSearchEngine == 'google' ? '-'+ val.lang : ''
                        state.regionList.push({
                         value: val.id, text: val.name +' ('+ val.regionCode + lang +')'
                        })
                    }
                    // set currentRegionId if it null
                    payload.th.currentRegionId = data.currentRegionData.id
                    // prepare field of table
                    payload.th.prepareTableField(data.positions)

                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_HISTORY: async ({state}, payload) => {
            payload.th.showOverlay ++;
            state.historyData = {};
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-positions-history/'+ state.currentSearchEngine +'/'+ payload.id +
                    '?from='+ payload.from +'&to='+ payload.to,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data
                    state.historyData = {
                        labels: [],
                        datasets: [
                            {
                                label: 'частота',
                                data: [],
                                backgroundColor: '#e5e5e5',
                                borderWidth: 1
                            },
                            {
                                label: 'позиция',
                                data: [],
                                backgroundColor: '#555555',
                                borderWidth: 1
                            }
                        ]
                    }
                    for (let key in data) {
                        state.historyData.labels.push(data[key].year +'-'+ data[key].month +'-'+ data[key].day);
                        let frequency = data[key].frequency == 'null' ? 0 : data[key].frequency
                        let position = data[key].position == 'null' ? 0 : data[key].position
                        state.historyData.datasets[0].data.push(frequency);
                        state.historyData.datasets[1].data.push(position);
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --
                },
            });
        }
    }
}